module.exports = __webpack_public_path__ + "static/img/pressure-img.2e99ae95.png";